import { parseISO } from 'date-fns'

import { type RouteLocale, ROUTE_LOCALE } from '@/domain/locale'
import { type AvailableDate } from '@/features/listing/components/request-viewing/RequestViewForm/RequestViewingForm'

const getFrenchTimeFormat = (time: string) => time.replace(':', 'h')

const getEnglishTimeFormat = (time: string) => {
  if (!time) {
    return ''
  }

  const hours = parseInt(time.substring(0, 2))
  const minutes = time.substring(3)
  const period = hours >= 12 ? 'PM' : 'AM'
  const hoursAdjusted = hours % 12 === 0 ? 12 : hours % 12

  return `${hoursAdjusted}:${minutes}${period}`
}

const getEnglishFormat = (name: string, availability: string) => `${name} has requested a viewing

Preferred date/time
${availability}

Please reply to confirm the request`

const getFrenchFormat = (name: string, availability: string) => `${name} a demandé une visite

Date/heure souhaitée
${availability}

Veuillez répondre pour confirmer la demande`

const formatAvailabilityList = (availableDates: AvailableDate[], isFrench: boolean) => {
  const formattedAvailability = availableDates.map(({ date, timeFrom, timeTo }) => {
    const startTime = isFrench ? getFrenchTimeFormat(timeFrom) : getEnglishTimeFormat(timeFrom)
    const endTime = isFrench ? getFrenchTimeFormat(timeTo) : getEnglishTimeFormat(timeTo)

    const formattedDate = Intl.DateTimeFormat(isFrench ? 'fr-FR' : 'en-US', {
      day: 'numeric',
      month: isFrench ? 'short' : 'long',
    }).format(parseISO(date))

    return `• ${formattedDate}, ${startTime} - ${endTime}`
  })

  return formattedAvailability.join('\n')
}

export const buildRequestViewingMessage = (
  senderFullName: string,
  availableDates: AvailableDate[],
  locale: RouteLocale
) => {
  const isFrench = locale === ROUTE_LOCALE.fr

  const formattedAvailability = formatAvailabilityList(availableDates, isFrench)
  return isFrench
    ? getFrenchFormat(senderFullName, formattedAvailability)
    : getEnglishFormat(senderFullName, formattedAvailability)
}
